import { font, space } from '@design/templateFns';
import styled from 'styled-components';

export const SearchInput = styled.input<{ $isFocused: boolean; $showTabs: boolean }>`
  position: relative;
  width: 100% !important;
  height: 100%;
  ${font('body-md')};
  font-size: 16px; // IOS fix
  background-color: rgba(255, 255, 255, 0.95);
  padding: 10px ${space('md')};
  z-index: 2;
  border: 1px solid #e5e5e5;
  outline: none;
  appearance: none;
  border-radius: ${({ $isFocused, $showTabs }) => {
    if ($showTabs) {
      return $isFocused ? '0 4px 0 0' : '0 4px 4px 4px';
    } else {
      return $isFocused ? '4px 4px 0 0' : '4px';
    }
  }};
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);

  &::placeholder {
    color: #666;
  }

  &:focus {
    outline: none;
  }

  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInputIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 8px;
  z-index: 3;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
`;

export const AutocompleteDropdown = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  border-radius: 0 0 4px 4px;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  z-index: 100;
`;

export const PredictionGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
`;

export const PredictionGroupHeader = styled.div<{ $isClickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 6px 12px;
  font-weight: bold;
  font-size: 16px;
  color: #0d0d0d;

  hr {
    border-color: #e5e5e5;
    flex-grow: 1;
  }

  &:hover {
    cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
    background-color: ${({ $isClickable }) =>
      $isClickable ? 'rgba(0, 0, 0, 0.07)' : 'transparent'};
  }
`;

export const PredictionItem = styled.span`
  display: flex;
  align-items: center;
  padding: 6px 24px 6px 44px;
  list-style-type: none;
  cursor: pointer;
  &:hover,
  &:focus,
  &.active {
    background-color: rgba(0, 0, 0, 0.07);
  }
`;

export const PredictionItemText = styled.span`
  padding-right: 12px;
  font-size: 16px;
  color: #0d0d0d;
`;

export const PredictionType = styled.span`
  ${font('body-xs')};
  text-transform: uppercase;
  letter-spacing: 2px;
  padding-top: 2px;
  color: #0d0d0d;
`;

export const ViewMoreButton = styled.span`
  cursor: pointer;
  text-decoration: underline;
  align-self: flex-end;
  font-size: 14px;
  padding: 0 12px;
`;
